// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__26LfW","range":"MonthRangeSwitch_range__1_5Oq","disabled":"MonthRangeSwitch_disabled__3uFu4"};